// extracted by mini-css-extract-plugin
export default {"link":"VerifyEmail_link__eNI10","linkWrapper":"VerifyEmail_linkWrapper__F9x7d"};